import { MutationTree } from 'vuex';
import { GatewayState } from './types';
import * as types from './mutation-types';

// エラーをクリアする
const resetErrors = (state: GatewayState): void => {
    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const sshConnect = state.sshConnect;
    sshConnect.error = false;
    sshConnect.errorCode = undefined;
    sshConnect.errorMsg = undefined;

    const rdpFileDownloadState = state.rdpFileDownload;
    rdpFileDownloadState.error = false;
    rdpFileDownloadState.errorCode = undefined;
    rdpFileDownloadState.errorMsg = undefined;

    const sessionToken = state.sessionToken;
    sessionToken.error = false;
    sessionToken.errorCode = undefined;
    sessionToken.errorMsg = undefined;
};

export const mutations: MutationTree<GatewayState> = {
    // ゲートウェイの環境変数取得系
    [types.SETTING_SHOW_START](state) {
        resetErrors(state);
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SETTING_SHOW_SUCCESS](state, payload) {
        const showState = state.show;
        state.gatewayAllowSettings = payload;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SETTING_SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // SSH接続用URL取得系
    [types.SSH_CONNECT_START](state) {
        resetErrors(state);
        const sshConnect = state.sshConnect;
        sshConnect.isProcessing = true;
    },

    [types.SSH_CONNECT_SUCCESS](state, payload) {
        state.sshConnectUrl = payload;
        const sshConnect = state.sshConnect;
        sshConnect.isProcessing = false;
    },

    [types.SSH_CONNECT_FAILURE](state, payload: { code: string; message: string }) {
        const sshConnect = state.sshConnect;
        sshConnect.errorCode = payload.code;
        sshConnect.errorMsg = payload.message;
        sshConnect.error = true;
        sshConnect.isProcessing = false;
    },

    // RDPファイルダウンロード系
    [types.RDP_FILE_DOWNLOAD_START](state) {
        resetErrors(state);
        const rdpFileDownloadState = state.rdpFileDownload;
        rdpFileDownloadState.isProcessing = true;
    },

    [types.RDP_FILE_DOWNLOAD_SUCCESS](state) {
        const rdpFileDownloadState = state.rdpFileDownload;
        rdpFileDownloadState.isProcessing = false;
    },

    [types.RDP_FILE_DOWNLOAD_FAILURE](state, payload: { code: string; message: string }) {
        const rdpFileDownloadState = state.rdpFileDownload;
        rdpFileDownloadState.errorCode = payload.code;
        rdpFileDownloadState.errorMsg = payload.message;
        rdpFileDownloadState.error = true;
        rdpFileDownloadState.isProcessing = false;
    },

    // セッショントークン取得系
    [types.SESSION_TOKEN_START](state) {
        resetErrors(state);
        const sshConnect = state.sessionToken;
        sshConnect.isProcessing = true;
    },

    [types.SESSION_TOKEN_SUCCESS](state, payload) {
        state.token = payload;
        const sessionToken = state.sessionToken;
        sessionToken.isProcessing = false;
    },

    [types.SESSION_TOKEN_FAILURE](state, payload: { code: string; message: string }) {
        const sessionToken = state.sessionToken;
        sessionToken.errorCode = payload.code;
        sessionToken.errorMsg = payload.message;
        sessionToken.error = true;
        sessionToken.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const sshConnect = state.sshConnect;
        sshConnect.isProcessing = false;

        const rdpFileDownloadState = state.rdpFileDownload;
        rdpFileDownloadState.isProcessing = false;

        const sessionToken = state.sessionToken;
        sessionToken.isProcessing = false;
    },

    [types.ERROR_RESET](state) {
        resetErrors(state);
    },

    [types.CLEAR_ALL](state) {
        state.sshConnectUrl = undefined;
        state.token = undefined;

        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;

        const sshConnect = state.sshConnect;
        sshConnect.error = false;
        sshConnect.errorCode = undefined;
        sshConnect.errorMsg = undefined;

        const rdpFileDownloadState = state.rdpFileDownload;
        rdpFileDownloadState.error = false;
        rdpFileDownloadState.errorCode = undefined;
        rdpFileDownloadState.errorMsg = undefined;

        const sessionToken = state.sessionToken;
        sessionToken.error = false;
        sessionToken.errorCode = undefined;
        sessionToken.errorMsg = undefined;
    },
};
